module.exports = __webpack_public_path__ + "static/intro-61a02c5ec1245a276291c21765915cb5.mp4";